module.exports = __webpack_public_path__ + "img/10.5a11c964.jpg";